import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { tomos } from '../data/content';
export function CourseAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-16 sm:py-24" aria-labelledby="contenido-title" data-id="element-31" data-mp="1ruxktc4lxyl4">
      <div className="mx-auto max-w-4xl px-5" data-id="element-32" data-mp="v5g667nnd27a">
        <div className="text-center" data-id="element-33" data-mp="v6rbibwqqi0i">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-olive" data-id="element-34" data-mp="z69v94ctsn1r">
            Contenido
          </span>
          <h2 id="contenido-title" className="mt-3 font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl" data-id="element-35" data-mp="145cz4lh2kn85">
            Negocio Rentable
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-forest-deep/75" data-id="element-36" data-mp="2fjqc2vaabi9e">
            El sistema práctico para controlar los números de tu negocio y
            decidir mejor.
          </p>
        </div>

        <div className="mt-10 space-y-3" data-id="element-37" data-mp="3vz4gpihp5ptp">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={tomo.number} className={`overflow-hidden rounded-2xl border transition-colors duration-200 ${isOpen ? 'border-forest bg-sage-mist shadow-card' : 'border-sage/70 bg-white'}`} data-id="element-38" data-mp="3mypqc4pvlkjc" data-mpi={index}>
                <h3 data-id="element-39" data-mp="389jjbuksqq0w">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`tomo-panel-${index}`} className="flex w-full items-center gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-forest sm:px-6" data-id="element-40" data-mp="3891sjdgwl40d">
                    <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-display text-sm font-extrabold transition-colors ${isOpen ? 'bg-forest text-white' : 'bg-sage-light text-forest'}`} data-id="element-41" data-mp="2pdjyr4u5eorc">
                      {index + 1}
                    </span>
                    <span className="flex-1" data-id="element-42" data-mp="2yemgml0anet3">
                      <span className="block text-[11px] font-bold uppercase tracking-[0.18em] text-olive" data-id="element-43" data-mp="2yew7eat5xpzu">
                        {tomo.number}
                      </span>
                      <span className="mt-0.5 block font-display text-base font-bold leading-snug text-black sm:text-lg" data-id="element-44" data-mp="2pmu5s97cy3nz">
                        {tomo.title}
                      </span>
                    </span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors ${isOpen ? 'border-forest bg-forest text-white' : 'border-sage text-forest'}`} aria-hidden="true" data-id="element-45" data-mp="3hcf6omptju92">
                      {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-46" data-mp="1kgubtuwgjyb6" /> : <PlusIcon className="h-4 w-4" data-id="element-47" data-mp="1fg6mrershrjl" />}
                    </span>
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-48" data-mp="mriwf4s6obz6">
                  {isOpen && <motion.div id={`tomo-panel-${index}`} key="panel" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.4, 0, 0.2, 1]
              }} className="overflow-hidden" data-id="element-49" data-mp="11o9zpp4za7u2">
                      <ul className="grid gap-2 px-5 pb-6 sm:grid-cols-2 sm:px-6" data-id="element-50" data-mp="ho9wg5npsgjg">
                        {tomo.items.map(item => <li key={item} className="flex items-start gap-2 text-sm text-forest-deep/80" data-id="element-51" data-mp="moflde2lnoxu">
                            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-olive" aria-hidden="true" data-id="element-52" data-mp="vob17w73o847" />
                            <span data-id="element-53" data-mp="15jcpyqxgr869">{item}</span>
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}